const apis = {
  apiConfig: {
    host: 'stage1-filter-api.project1service.com',
    uri: 'filter-api.project1service.com',
  },

  apiSite: {
    host: 'stage1-site-api.project1service.com',
    uri: 'site-api.project1service.com',
  },
};

export {
  apis,
};
